/** @format */
import React, { FunctionComponent, HTMLAttributes, useContext } from 'react';
import styled from 'styled-components';

import { ContentfulQueryId } from '@toucan/common/contentful';

import { MediaQuery, useMediaQuery } from '@toucan/client/global/application';
import { MarketContext } from '@toucan/client/global/market';

import {
    ContentBlockCollection as ContentBlockCollectionData,
    SiteSection,
    getPageDataPart,
} from '@toucan/client/core/contentful';

import { StoryCardCollection } from '@toucan/client/features/contentful/components/story-card-collection';
import { contentBlockCollectionToStoryCards } from '@toucan/client/features/contentful/helpers/adapters/contentful';
import { usePageData } from '@toucan/client/features/contentful/hooks/use-page-data';

import { styles } from './content-block-collection.styles';

type ContentBlockCollectionProps = {
    siteSection: SiteSection;
} & HTMLAttributes<HTMLDivElement>;

const StyledContentBlockCollection = styled.div`
    ${styles}
`;

export const ContentBlockCollection: FunctionComponent<
    ContentBlockCollectionProps
> = ({ siteSection, ...otherProps }) => {
    const isLargeTablet = useMediaQuery(MediaQuery.LARGE_TABLET);
    const { activeMarket } = useContext(MarketContext);

    const { pageData, loading: isLoadingPageData } = usePageData({
        siteSection,
        queryId: ContentfulQueryId.CONTENT_BLOCK_COLLECTION,
    });

    const contentBlockCollection = getPageDataPart<ContentBlockCollectionData>({
        data: pageData,
        siteSection,
        typename: 'ContentBlockCollection',
    });

    const contentBlocks = contentBlockCollectionToStoryCards(
        contentBlockCollection,
        activeMarket.slug
    );

    const columnCount = isLargeTablet ? 1 : 3;

    return (
        <StyledContentBlockCollection {...otherProps}>
            <StoryCardCollection
                loading={isLoadingPageData}
                skeletonCount={3}
                columnCount={columnCount}
                className="call-to-action"
            >
                {contentBlocks}
            </StoryCardCollection>
        </StyledContentBlockCollection>
    );
};
